import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import { getUserInfoFromLocalStorage } from '@/utils/auth'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import { getLanguage } from '@/utils/localization'

@inject('store')
@observer
export default class NavbarComponent extends Component {
  render() {
    const lang = getLanguage()
    return (
      <Fragment>
        <header id="navbar">
          <div className="logo">
            <Link to={`/${lang}`}></Link>
          </div>
          <div className="subMenu">
            <div className="menu inline-block vertical-middle">
              <Link to={`/${lang}/info`}>
                <span className="text text--16 mg ml-40">
                  {getStringByTextKey('navBar.home.mainFeatures')}
                </span>
              </Link>
              <Link to={`/${lang}/product`}>
                <span className="text text--16 mg ml-40">
                  {getStringByTextKey('navBar.home.productPurchase')}
                </span>
              </Link>
              <Link to={`/${lang}/request`}>
                <span className="text text--16 mg ml-40">
                  {getStringByTextKey('navBar.home.inquiry')}
                </span>
              </Link>
              <Link to={`/${lang}/company`}>
                <span className="text text--16 mg ml-40">
                  {getStringByTextKey('navBar.home.company')}
                </span>
              </Link>
              {getUserInfoFromLocalStorage() ? (
                <Link to={`/${lang}/console`}>
                  <span className="text text--16 text--green mg ml-40">
                    {getStringByTextKey('navBar.home.console')}
                  </span>
                </Link>
              ) : (
                <Link to={`/${lang}/login`}>
                  <span className="text text--16 text--green mg ml-40">
                    {getStringByTextKey('logIn.title')}
                  </span>
                </Link>
              )}
              {getUserInfoFromLocalStorage() ? (
                ''
              ) : (
                <Link to={`${lang}/join`}>
                  <span className="text text--16 text--green mg ml-40">
                    {getStringByTextKey('logIn.signUp.title')}
                  </span>
                </Link>
              )}
            </div>
          </div>
        </header>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/Navbar/index.js